import React from 'react';
import { Spin } from 'antd';
import logo from '../../public/assets/logo/logo.png';

interface SpinnerLoaderProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
}

export const CarLoader: React.FC = () => (
  <div className="cl-panel">
    <img
      src={logo}
      alt="Loading"
      className="sl-steering"
      draggable={false}
    />
  </div>
);

const SpinnerLoader: 
   React.FC<SpinnerLoaderProps> = ({ size = 'default', tip = 'Loading...' }) => {
  return (
    <div
    className="spinnerLoader">
      <CarLoader />
    </div>
  );
};

export default SpinnerLoader;